module.exports = __webpack_public_path__ + "img/ac.8ab65b71.svg";